var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconStudents = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "2 students"
}, /*#__PURE__*/React.createElement("g", {
  id: "student"
}, /*#__PURE__*/React.createElement("path", {
  id: "Subtract",
  d: "M20.5366 14.9517C20.5368 16.5455 21.8285 17.8373 23.4224 17.8374C25.0164 17.8374 26.3089 16.5456 26.3091 14.9517V13.6685L24.3022 14.561C23.7426 14.8098 23.1032 14.8097 22.5435 14.561L20.5366 13.6685V14.9517ZM17.6499 16.0337C17.6499 16.3326 17.892 16.5747 18.1909 16.5747C18.4898 16.5747 18.7319 16.3326 18.7319 16.0337V12.8667L17.6704 12.395C17.6633 12.3919 17.6566 12.3868 17.6499 12.3833V16.0337Z",
  fill: "#0073DE"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector 1456",
  d: "M29.1754 12.2681L24.3019 10.1021C23.7422 9.85333 23.1032 9.85333 22.5435 10.1021L17.67 12.2681C17.3843 12.3951 17.3843 12.8005 17.67 12.9275L22.5435 15.0935C23.1032 15.3423 23.7422 15.3423 24.3019 15.0935L29.1754 12.9275C29.4611 12.8005 29.4611 12.3951 29.1754 12.2681Z",
  fill: "#0073DE"
}), /*#__PURE__*/React.createElement("path", {
  id: "Subtract_2",
  d: "M21.7632 19.3808C21.5861 19.2018 21.328 19.1252 21.0864 19.1962C20.3776 19.4046 19.7455 19.7076 19.2212 20.0771C20.4693 21.2201 21.2063 22.6248 21.2114 24.1435H27.7524C28.5495 24.1435 29.1958 23.4972 29.1958 22.7001C29.1957 21.1363 27.7834 19.7914 25.7593 19.1962C25.5177 19.1252 25.2596 19.2018 25.0825 19.3808L23.936 20.54C23.6536 20.8254 23.1921 20.8254 22.9097 20.54L21.7632 19.3808Z",
  fill: "#0073DE"
})), /*#__PURE__*/React.createElement("g", {
  id: "student_2"
}, /*#__PURE__*/React.createElement("path", {
  id: "Subtract_3",
  d: "M6.50977 12.6255C6.50977 15.0574 8.48116 17.0288 10.9131 17.0288C13.345 17.0288 15.3164 15.0574 15.3164 12.6255V10.6685L12.2539 12.0298C11.4001 12.4092 10.4251 12.4093 9.57129 12.0298L6.50977 10.6685V12.6255ZM2.10645 14.2769C2.10645 14.7328 2.47577 15.1019 2.93164 15.1021C3.38763 15.1021 3.75781 14.7328 3.75781 14.2769V9.44482L2.13672 8.7251C2.12622 8.72042 2.11644 8.71463 2.10645 8.70947V14.2769Z",
  fill: "#0073DE"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector 1456_2",
  d: "M19.6887 7.71978L12.2541 4.4155C11.4002 4.03598 10.4255 4.03598 9.57155 4.4155L2.13693 7.71978C1.7011 7.91348 1.7011 8.53204 2.13693 8.72574L9.57155 12.03C10.4255 12.4095 11.4002 12.4095 12.2541 12.03L19.6887 8.72574C20.1246 8.53204 20.1246 7.91348 19.6887 7.71978Z",
  fill: "#0073DE"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M8.3815 18.5704L10.1302 20.3387C10.5611 20.7744 11.2648 20.7744 11.6957 20.3387L13.4444 18.5704C13.7146 18.2973 14.1089 18.1808 14.4775 18.2892C17.5655 19.1973 19.7197 21.2491 19.7197 23.6348C19.7197 24.8508 18.734 25.8365 17.518 25.8365H4.30787C3.09191 25.8365 2.10618 24.8508 2.10618 23.6348C2.10618 21.2491 4.26038 19.1973 7.34841 18.2892C7.71698 18.1808 8.11135 18.2973 8.3815 18.5704Z",
  fill: "#0073DE"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconStudents);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-students.c2c06a03859ad009cc8796943268368c.svg";